import { render } from "./verifyemail.vue?vue&type=template&id=06c7a3b7&scoped=true&class=%20font-nunito"
import script from "./verifyemail.vue?vue&type=script&lang=js"
export * from "./verifyemail.vue?vue&type=script&lang=js"

import "./verifyemail.vue?vue&type=style&index=0&id=06c7a3b7&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-06c7a3b7"

export default script